export default __webpack_public_path__ + "static/media/bor-img.7bb1880d.svg";